import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { register } from 'swiper/element/bundle';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import { initBirdie } from '@birdie-so/snippet';

// Birdie must be loaded once the page is retrieved from the server (index.html).
// It can't wait to bootstrap angular because it wouldn't catch the APP_INITIALIZER events.
initBirdie({
  clientId: environment.birdieClientId,
  onReady(birdie) {
    window.birdieApi = birdie;
  }
});

if (environment.production) {
  enableProdMode();
}

register();

dayjs.extend(duration);
dayjs.extend(customParseFormat);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    console.error(err);
    let localStorageAllowed = true;

    try {
      localStorage.setItem('test', 'test');
      localStorage.removeItem('test');
    } catch (e) {
      localStorageAllowed = false;
    }

    const body = document.querySelector('body');
    const divEl = document.createElement('div');
    divEl.style.padding = '20px';
    divEl.style.lineHeight = '20px';

    divEl.innerHTML =
      `<h1>An error has occurred and the application cannot be loaded</h1><p>Please, make sure you allow cookies ` +
      `and local storage for this site. Once the app is loaded, you can configure your preferences.</p>` +
      `<ul style="margin-top: 10px"><li>\uD83C\uDF6A Cookies allowed: ${navigator.cookieEnabled}</li>` +
      `<li>\uD83D\uDCBE Local storage allowed: ${localStorageAllowed}</li></ul>`;

    body.replaceWith(divEl);
  });
